import React from "react";
import "./button-primary.scss";
import CSS from "csstype";

interface ButtonPrimaryProps {
    value?: string;
    onClick?: () => void;
    children?: JSX.Element | string;
    disabled?: boolean;
    type?: "button" | "submit" | "reset";
    style?: CSS.Properties;
}

export const ButtonPrimary = (props: ButtonPrimaryProps) => {
    return (
        <button
            disabled={props.disabled}
            type={props.type}
            onClick={props.onClick}
            className="btn-primary"
            value={props.value}
            style={props.style}
        >
            {props.children}
        </button>
    );
};

export const ButtonPrimarySmall = (props: ButtonPrimaryProps) => {
    return (
        <button
            disabled={props.disabled}
            type={props.type}
            onClick={props.onClick}
            className="btn-primary"
            value={props.value}
            style={{ display: "flex", alignItems: "center", fontSize: "1rem", padding: "0 2rem", height: "2.5rem" }}
        >
            {props.children}
        </button>
    );
};
